import { useMutation } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';

export interface MappedSegment {
  id: string;
  realmId: string;
  userId: string;
  projectId: string;
  name: string;
  description: string | null;
}

const getMappedSegments = async (treatmentId: string): Promise<MappedSegment[]> => {
  try {
    const url = paths.getMappedSegments();
    const response = await axiosInstance.post(url, {
      input: { query: `featureTreatmentId==${treatmentId}` }
    });
    
    const mappedSegments = response?.data?.data?.mappedSegments?.result || [];
    return mappedSegments;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useGetMappedSegments = () => {
  return useMutation(getMappedSegments);
};